import type { EcsServiceSnapshot } from '@ms/yammer-experiments';
import { loadEcsTreatments as loadModuleEcsTreatments } from '@ms/yammer-experiments';
import type { ManagedApiCaching } from '@ms/yammer-libs-api';
import type { EcsPersistKey } from '@ms/yammer-libs-static-config';
import type { RequestInitiator } from '@ms/yammer-telemetry-support';

import type { PromiseThunkAction } from '../../types';

import type { LoadEcsTreatmentsFulfilledAction } from './actions.types';
import type { EcsUserContext } from './ecsQuery';

export interface LoadEcsTreatmentsOptions {
  readonly caching?: Omit<ManagedApiCaching, 'key'>;
  readonly persistKey?: string;
  readonly initiator?: RequestInitiator;
  readonly userContext?: EcsUserContext;
}

export type LoadEcsTreatments = (options?: LoadEcsTreatmentsOptions) => PromiseThunkAction<void>;

const isEcsPersistKey = (persistKey: string): persistKey is EcsPersistKey =>
  /^(embed|teams|teamsMeeting|teams-branded-exp|web(?:-.+)?)$/.test(persistKey);

const getEcsPersistKey = (persistKey: string | undefined): EcsPersistKey | undefined => {
  if (persistKey === undefined || isEcsPersistKey(persistKey)) {
    return persistKey;
  }

  throw new Error(`Unsupported ECS persist key: ${String(persistKey)}`);
};

const loadEcsTreatmentsFulfilled = (snapshot: EcsServiceSnapshot): LoadEcsTreatmentsFulfilledAction => ({
  type: 'FEATURE_FLIGHTING.LOAD_ECS_TREATMENTS_FULFILLED',
  payload: {
    ecsConfig: snapshot.ecsConfig,
    ecsExperimentTreatments: snapshot.experimentTreatmentsFromService,
    ecsFeatureRolloutTreatments: snapshot.featureRolloutTreatmentsFromService,
  },
});

const loadEcsTreatmentsAction: LoadEcsTreatments = (options) => async (dispatch) => {
  await loadModuleEcsTreatments({
    ...options,
    persistKey: getEcsPersistKey(options?.persistKey),
    publishServiceSnapshot: (snapshot) => {
      dispatch(loadEcsTreatmentsFulfilled(snapshot));
    },
  });
};

export { loadEcsTreatmentsAction as loadEcsTreatments };
